import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "@env/environment";

@Injectable({
    providedIn: 'root'
})
export class IbgeApiService {
    private http = inject(HttpClient);
    private readonly apiServiceUrl = environment.serviceApi;

    getStates(): Observable<any> {
        return this.http.get(`${this.apiServiceUrl}/v1/ibge/states`);
    }

    getCitiesByState(uf: string): Observable<any> {
        return this.http.get(`${this.apiServiceUrl}/v1/ibge/states/${uf}/municipalities`);
    }
}

